var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L9.19286 4.32493C9.52566 5.53158 10.4684 6.47434 11.6751 6.80714L16 8L11.6506 9.23312C10.4575 9.57138 9.52683 10.5068 9.19472 11.7017L8 16L6.76488 11.6771C6.4274 10.4959 5.5041 9.5726 4.32292 9.23512L0 8L4.29832 6.80528C5.49316 6.47317 6.42862 5.54252 6.76688 4.34941L8 0Z",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.f93ed35a6a3068b71feb81dc3222ed4d.svg";
export { ForwardRef as ReactComponent };